<template>
  <div class="prviewWord">
    <div ref="file"></div>
  </div>
</template>

<script>
import axios from 'axios'
const docx = require('docx-preview');
window.JSZip = require('jszip')
export default {
  props: {
    url: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    url: {
      handler(val) {
        axios({
          method: 'get',
          responseType: 'blob', // 设置响应文件格式
          url: this.url,
        }).then(({data}) => {
          docx.renderAsync(data,this.$refs.file) // 渲染到页面预览
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
